import React, { useState, useEffect, useRef } from 'react';
import ChatBubble from './ChatBubble';
import MessageInput from './MessageInput';
import './Chat.css';

const ChatWindow = ({ conversation, messages, onSendMessage, onMarkRead }) => {
  const messagesEndRef = useRef(null);
  const [isTyping, setIsTyping] = useState(false);

  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
  };

  useEffect(() => {
    scrollToBottom();
  }, [messages]);

  useEffect(() => {
    if (conversation) {
      // Mark messages as read when opening conversation
      onMarkRead(conversation.id);
    }
  }, [conversation]);

  const handleSendMessage = async (message) => {
    setIsTyping(true);
    try {
      await onSendMessage(conversation.id, message);
    } finally {
      setIsTyping(false);
    }
  };

  if (!conversation) {
    return (
      <div className="chat-window empty">
        <div className="empty-state">
          <h3>No conversation selected</h3>
          <p>Select a conversation from the list to start chatting</p>
        </div>
      </div>
    );
  }

  return (
    <div className="chat-window">
      <div className="chat-header">
        <div className="contact-info">
          <div className="contact-avatar">
            <div className="avatar-circle-large">
              {conversation.contact.name?.charAt(0).toUpperCase() || '?'}
            </div>
          </div>
          <div className="contact-details">
            <h3>{conversation.contact.name || 'Unknown Contact'}</h3>
            <p>{conversation.contact.phone_number}</p>
          </div>
        </div>
      </div>

      <div className="chat-messages">
        {messages.length === 0 ? (
          <div className="no-messages">
            <p>No messages yet. Start the conversation!</p>
          </div>
        ) : (
          messages.map((message) => (
            <ChatBubble
              key={message.id}
              message={message}
              isOutbound={message.direction === 'outbound'}
            />
          ))
        )}
        {isTyping && (
          <div className="typing-indicator">
            <span></span>
            <span></span>
            <span></span>
          </div>
        )}
        <div ref={messagesEndRef} />
      </div>

      <MessageInput onSendMessage={handleSendMessage} disabled={isTyping} />
    </div>
  );
};

export default ChatWindow;
